/**
 * @generated SignedSource<<dacc7e71d9572b1625dd872d262b6717>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoContainer_videoVimeo$data = {
  readonly vimeoId: string | null;
  readonly " $fragmentType": "VideoContainer_videoVimeo";
};
export type VideoContainer_videoVimeo$key = {
  readonly " $data"?: VideoContainer_videoVimeo$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoContainer_videoVimeo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VideoContainer_videoVimeo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vimeoId",
      "storageKey": null
    }
  ],
  "type": "VideoVimeo",
  "abstractKey": null
};

(node as any).hash = "b150dfc5c95915c3c1644c12dcdc5a58";

export default node;
